import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from 'tslib';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import React, { useState } from 'react';
import classnames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';
import { DropzoneOverlayDefault, DropzoneOverlayContainer } from './elements.js';

/**
 * This component is used to wrap your component to enable drag and drop
 * functionality over it.
 */
var Dropzone = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var children = _a.children,
    className = _a.className,
    inverted = _a.inverted,
    _a$isActive = _a.isActive,
    isActive = _a$isActive === undefined ? true : _a$isActive,
    _a$overlayComponent = _a.overlayComponent,
    overlayComponent = _a$overlayComponent === undefined ? jsx(DropzoneOverlayDefault, {}) : _a$overlayComponent,
    fullPageOverlay = _a.fullPageOverlay,
    onDrop = _a.onDrop,
    otherProps = __rest(_a, ["children", "className", "inverted", "isActive", "overlayComponent", "fullPageOverlay", "onDrop"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragOver = _useState2[0],
    setIsDragOver = _useState2[1];
  var handleDrag = function handleDrag(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setIsDragOver(true);
    } else if (e.type === 'dragleave') {
      setIsDragOver(false);
    }
  };
  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    setIsDragOver(false);
    onDrop === null || onDrop === undefined ? undefined : onDrop(e);
  };
  if (!isActive) {
    return jsx(Fragment, {
      children: children
    });
  }
  return jsxs("div", Object.assign({
    ref: ref,
    className: classnames.apply(undefined, ['cogs-lab', 'cogs-dropzone'].concat(_toConsumableArray(getThemeClassNames(inverted)), [className]))
  }, otherProps, {
    onDrop: handleDrop,
    onDragOver: handleDrag,
    onDragEnter: handleDrag,
    onDragLeave: handleDrag,
    children: [children, jsx(DropzoneOverlayContainer, {
      visible: !!isDragOver,
      fullPage: fullPageOverlay,
      children: overlayComponent
    })]
  }));
});

export { Dropzone };
